import type { BuildIntake, StackPreference, TargetOutput } from "../../types";
import { uid } from "../storage";

export interface IntakeFormData {
  projectName: string;
  projectType: string;
  targetOutput: TargetOutput;
  stackPreference: StackPreference;
  sourceNotes: string;
  constraints: string;
}

export function createBuildIntake(data: IntakeFormData): BuildIntake {
  return {
    id: uid("intake"),
    projectName: data.projectName.trim(),
    projectType: data.projectType.trim(),
    targetOutput: data.targetOutput,
    stackPreference: data.stackPreference,
    sourceNotes: data.sourceNotes.trim(),
    constraints: data.constraints.trim(),
    noApiPaywall: true,
    createdAt: new Date().toISOString(),
  };
}

export function validateIntake(data: IntakeFormData): string[] {
  const errors: string[] = [];
  if (!data.projectName.trim()) errors.push("Project name is required.");
  if (!data.projectType.trim()) errors.push("Project type is required.");
  return errors;
}
